import React, {useState} from 'react';
import api from "../../services/api";
import {
    Badge,
    NavLink
} from '@mantine/core';
import {IconHome, IconLogout, IconUser, IconLogin} from '@tabler/icons-react';

const NavBar = (props) => {
    const {authUser, setAuthUser} = props
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const refresh = localStorage.getItem('refresh');
    const logout = async () => {
        try {
            const response = await api.post('/users/logout/', {refresh});
        } catch (err) {
            setError('Erreur lors du chargement des données utilisateur');
        } finally {
            setLoading(false);
            setAuthUser(false);
            localStorage.clear();
        }
    };

    const navLinksData = [
        // liens identification
        {href: "/login", label: "Se connecter", icon: <IconLogin size="2rem" stroke={2}/>},
        {onClick: logout, label: "Logout", icon: <IconLogout size="2rem" stroke={2}/>, auth_user: true},
    ];

    return (
        <>
            {navLinksData.map((link, index) => (
                ((!link.auth_user && authUser === false) || (link.auth_user === true && authUser === true)) && (
                    <NavLink
                        key={index}
                        href={link.href}
                        label={link.label}
                        leftSection={link.icon}
                        description={link.description}
                        onClick={link.onClick}
                    />
                )
            ))}
        </>

    );
};

export default NavBar;